module.exports = __webpack_public_path__ + "static/media/b5-white-spanish.2c54abe0.png";